const prefix = 'ga4'

export const getNavUrl = (url: string) => {
  return `/${prefix}${url}`
}